import _ from 'lodash';

import { ElaboratedTicketGroup } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { calendarTicketGroupsSelector } from './ticketGroupsByDateTimeSelector';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';

export const ticketTypesByTableIdSelector = createSelector(
  calendarTicketGroupsSelector,
  (ticketGroups: ElaboratedTicketGroup[]) => {
    const tableIdToTicketTypeIds: Dictionary<number[]> = {};
    _.forEach(ticketGroups, (ticketGroup: ElaboratedTicketGroup) => {
      const ticketTypeIds = _.map(ticketGroup.ticketType, 'id') as number[];
      _.forEach(ticketGroup.tableId, (tableId: number) => {
        if (!tableIdToTicketTypeIds[tableId]) {
          tableIdToTicketTypeIds[tableId] = ticketTypeIds;
        } else {
          tableIdToTicketTypeIds[tableId] = _.union(tableIdToTicketTypeIds[tableId], ticketTypeIds);
        }
      });
    });
    return tableIdToTicketTypeIds;
  }
);

export const ticketTypesForTableIdSelector = createCachedSelector(
  ticketTypesByTableIdSelector,
  (state: StoreType, tableIds: number[]): number[] => tableIds,
  (ticketTypesByTableId: Dictionary<number[]>, tableIds: number[]): number[] => {
    let ticketTypeIds: number[] = [];
    if (_.isEmpty(tableIds)) {
      return [];
    }
    _.forEach(tableIds, (tableId: number) => {
      ticketTypeIds = _.union(ticketTypeIds, ticketTypesByTableId[tableId]);
    });

    return ticketTypeIds;
  }
)((state: StoreType, tableIds?: number[]) => `_${_.join(tableIds, '')}`);
